import { ResourceChannel } from "@/services/resources";
import { defineStore } from "pinia";
import { useDataFiltersStore } from "@/store/data_filters";
import { DateTime } from "luxon";
import { useLocalStorage } from "@vueuse/core";

export const useOrganizationStore = defineStore("organization", {
  state: () => ({
    id: 0,
    dismissedBannerWarning: false,
    dismissedResourceIssueWarning: false,
    routeHasRequiredData: true,
  }),
  actions: {
    DISMISS_RESOURCE_MISSING_BANNER() {
      this.dismissedBannerWarning = true;
    },
    DISMISS_RESOURCE_ISSUE_BANNER() {
      this.dismissedResourceIssueWarning = true;
    },
    setRouteHasRequiredData(value: boolean): void {
      this.routeHasRequiredData = value;
    },
  },
});

export function useDataFilterInitialization({
  channels,
}: {
  channels: readonly ResourceChannel[];
}): void {
  const dataFiltersStore = useDataFiltersStore();
  dataFiltersStore.initializeDataFilters({
    availableChannels: channels,
  });
}

// Google Drive Picker Access Token
export const useGDPTokenStore = defineStore("gdpToken", {
  state: () => ({
    accessToken: useLocalStorage("gdpAccessToken", ""),
    expiresIn: useLocalStorage("gdpExpiresIn", 0),
    timestamp: useLocalStorage("gdpTimestamp", ""),
  }),

  actions: {
    setTokenInfo(accessToken: string, expiresIn: number): void {
      this.accessToken = accessToken;
      this.expiresIn = expiresIn;
      this.timestamp = DateTime.now().toISO();
    },

    clear(): void {
      this.accessToken = "";
      this.expiresIn = 0;
      this.timestamp = "";
    },

    isTokenValid(): boolean {
      if (!this.accessToken || !this.timestamp) return false;

      const tokenTime = DateTime.fromISO(this.timestamp);
      if (!tokenTime.isValid) return false;

      const expirationTime = tokenTime.plus({ seconds: this.expiresIn });
      return DateTime.now() < expirationTime;
    },
  },
});
